'use client';

import { useEffect, useState } from 'react';

import { getCookie } from '@workspace/lib/utils/cookies';
import { getLocale } from '@workspace/lib/utils/get-locale';

import { useAppRouter } from '@/hooks/use-app-router';
import type { Locale } from '@/i18n/request';

const locales = ['en', 'ro'] as const;

export function LocaleSwitch() {
  const [selectedLocale, setSelectedLocale] = useState(getLocale());
  const router = useAppRouter();

  // Note: check if cookie is already stored and set as selected
  useEffect(() => {
    const storedSiteLocale = getCookie('site-locale');

    if (storedSiteLocale && locales.includes(storedSiteLocale as Locale)) {
      setSelectedLocale(storedSiteLocale);
    }
  }, []);

  const handleLocaleSelect = (input: string) => {
    setSelectedLocale(input);
    document.cookie = `site-locale=${input}; path=/; max-age=604800; SamSite=Lax`;
    router.refresh();
  };

  return (
    <div className='flex gap-x-4 p-4'>
      {locales.map((locale, i) => {
        const key = `${locale}-${i}`;
        const id = `${locale}-locale`;
        const name = `${locale}_name`;
        const label = locale.toUpperCase();

        return (
          <div key={key} className='flex gap-x-2 text-base font-bold'>
            <input
              id={id}
              name={name}
              type='radio'
              checked={selectedLocale === locale}
              onChange={() => handleLocaleSelect(locale)}
              className='cursor-pointer'
            />
            <label htmlFor={id} className='cursor-pointer'>
              {label}
            </label>
          </div>
        );
      })}
    </div>
  );
}
